import {Component, OnDestroy, OnInit} from '@angular/core';
import { UrlHistoryService } from '../../services/url.history.service';
import {MenuUtils} from '../../utils/Utils';
import { AppStateService } from '../../services/app-state.service';
import { AppState } from '../../models/AppState';
import { Subscription } from 'rxjs';
import { MenuCategory, MenuItem, MenuSection } from '../../models/FSMenu';
import { MenuService } from '../../services/menu.service';
import moment from 'moment';
import {TranslateService} from "../../services/translate.service";
import { LoadingSpinnerComponent } from "../ui/loading-spinner-component";
import { CommonModule, NgIf } from '@angular/common';
import { CircleButtonComponent } from "../buttons/circle-button.component";
import { OrderService } from '../../services/order.service';
import { TipButtonComponent } from "../buttons/tip-button.component";
import { Router } from '@angular/router';
import { MenuItemComponent } from "../ui/menu-item.component";

@Component({
  selector: 'app-menu-of-the-week',
  standalone: true,
  imports: [
    LoadingSpinnerComponent,
    NgIf,
    CommonModule,
    CircleButtonComponent,
    TipButtonComponent,
    MenuItemComponent
],
  templateUrl: './menu-of-the-week.component.html'
})
export class MenuOfTheWeekComponent implements OnInit, OnDestroy {
  isLoading = false;
  private app?: AppState;
  private sub?: Subscription;
  promoUrl?: string;
  sections?: MenuSection[];
  categories: MenuCategory[] = [];
  visitems: MenuItem[] = [];
  filterWeekDay = 0;
  days: { name: string; ix: number }[] = [];

  constructor(private appState: AppStateService, private appStateService: AppStateService,
              public translate: TranslateService, private router: Router) { }

  ngOnInit(): void {
    this.sub = this.appState.observeAppState().subscribe(appState => {
      this.app = appState;
      this.promoUrl = MenuUtils.getRootPromoImgUrl(this.app.menu?.food);
      this.filterWeekDay = moment().isoWeekday() - 1;
      this.categories = this.getCategories(appState.menu.food);
      const daysString = this.getString("Mån,Tis,Ons,Tor,Fre");
      const days = daysString.split(",");
      this.days = [];
      for (let i = 0; i < days.length; i++) {
        this.days.push({ name: days[i], ix: i });
      }
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  back() {
    this.router.navigate([this.appStateService.venueId, "start"]);
  }

  showDay(num: number): void {
    this.filterWeekDay = num;
    const sectionsCopy = JSON.parse(JSON.stringify(this.app?.menu?.food ?? []));
    this.categories = this.getCategories(sectionsCopy);
  }

  private getCategories(sections: MenuSection[]): MenuCategory[] {   
    const cats: MenuCategory[] = [];
    let d = moment();
    const dayDiff = this.filterWeekDay - d.isoWeekday() + 1;
    d = moment().add(dayDiff, 'days');
  
    const itemFilter = this.app?.order ? MenuUtils.buildFilter(this.app.order, this.app.cfg) : null;
  
    if (this.app) {
      MenuUtils.updatePageHiddenFlag(
        sections,
        this.app.cfg,
        this.app.order,
        d,
        'whide',
        true,
        true,
        undefined,
        itemFilter ?? undefined
      );
    }

    return sections.reduce((cats: MenuCategory[], menuSec) => {
      menuSec.categories.forEach(menuCat => {
        if (!menuCat.whide) {
          menuCat.items = this.buildVisibleItems(menuCat);
          cats.push(menuCat);
        }
      });
      return cats;
    }, []);
  }  
  
  private buildVisibleItems(category: MenuCategory): MenuItem[] {
    return category.items?.filter(item => !item.whide) ?? [];
  }

  getPackagePrice(item: MenuItem): number {
    return MenuUtils.packageMenuPrice(item.package);
  }  
  
  getString(s: string, pc: string = "normal") {
    return this.translate.single(s, pc);
  }
}
